import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IconButton } from "@mui/material";
import deleteIcon from '../../assets/images/delete.svg';
import { getPracticeLocations } from "../../actions/userActions/practiceLocationAction";
import { toast } from 'react-toastify';
import SingleSelect from "../designSystem/SingleSelect";
import MultiSelect from "../designSystem/MultiSelect";
import { t } from "../../locales/translate";

function Doctorpracticelocationrow(props) {
    const [cityPracticeLocations, setCityPracticeLocations] = useState({});
    const dispatch = useDispatch();

    const cities = useSelector((state) => state.cities_reducer.cities);
    const fetchedPracticeLocations = useSelector((state) => state.practiceLocations_reducer.practiceLocations);
    useEffect(() => {
        if (fetchedPracticeLocations?.result) {
            const locations = fetchedPracticeLocations?.result;
            if (locations.length > 0) {
                const cityId = locations[0].city;
                setCityPracticeLocations(prev => ({
                    ...prev,
                    [cityId]: locations
                }));
            }
        }
    }, [fetchedPracticeLocations]);

    const handleRowChange = (rowIndex, field, value) => {
        if (field === "cityId") {
            const locationAlreadyExists = props.formValues.rows.some(
                (row, index) => index !== rowIndex && row.cityId === value
            );

            if (locationAlreadyExists) {
                toast.error("This city already exists in another row.");
                return;
            }

            props.setFormValues((prevState) => ({
                ...prevState,
                rows: prevState.rows.map((row, index) =>
                    index === rowIndex
                        ? {
                            ...row,
                            cityId: value,
                            practiceLocationIds: []
                        }
                        : row
                ),
            }));

            if (!cityPracticeLocations[value]) {
                const practiceLocationBody = {
                    pageNumber: -1,
                    filter: { textSearch: "", city: value },
                    pageSize: 0,
                };
                dispatch(getPracticeLocations(practiceLocationBody));
            }
        }
    };

    const handleMultiSelectRowChange = (rowIndex, values) => {
        props.setFormValues((prevState) => ({
            ...prevState,
            rows: prevState.rows.map((row, index) =>
                index === rowIndex
                    ? {
                        ...row,
                        practiceLocationIds: values
                    }
                    : row
            ),
        }));
    };
    const handleDeleteClick = (rowIndex) => {
        props.setFormValues((prevState) => ({
            ...prevState,
            rows: prevState.rows.filter((_, index) => index !== rowIndex)
        }));
    };
    const getOptions = (type, cityId) => {
        if (type === "cities") {
            return cities?.result
                ?.sort((a, b) => a.name.localeCompare(b.name))
                .map((city) => ({
                    value: city.id,
                    label: city.name,
                })) || [];
        }

        if (type === "practiceLocations") {
            const locationsForCity = cityPracticeLocations[cityId] || [];
            return locationsForCity.map((location) => ({
                value: location.id,
                label: location.name,
            }));
        }

        return [];
    };

    useEffect(() => {
        if (props.row.cityId && !cityPracticeLocations[props.row.cityId]) {
            const practiceLocationBody = {
                pageNumber: -1,
                filter: { textSearch: "", city: props.row.cityId },
                pageSize: 0,
            };
            dispatch(getPracticeLocations(practiceLocationBody));
        }
    }, []);

    return (
        <>
            <div key={`${props.row.cityId}-${props.index}`} className="p-3 mb-3 maindiv">
                <div className="add-doctor-rounded-fields-container">
                    <div className="row align-items-center">
                        <div className="col-6">
                            <SingleSelect
                                label={`${t("city")} *`}
                                isSearchable
                                secondaryLabel
                                iconEnd
                                error={props.formErrors?.rows?.[props.index]?.cityId}
                                onChange={(e) => handleRowChange(props.index, "cityId", e.value)}
                                value={props.row.cityId}
                                placeholder={t("city")}
                                options={getOptions("cities")}
                            />
                        </div>
                        <div className="col-6">
                            <MultiSelect
                                label={`${t("practiceLocation")} *`}
                                isSearchable
                                secondaryLabel
                                iconEnd
                                error={props.formErrors?.rows?.[props.index]?.practiceLocationIds}
                                onChange={(values) => handleMultiSelectRowChange(props.index, values)}
                                value={props.row.practiceLocationIds}
                                placeholder={t("practiceLocation")}
                                options={getOptions("practiceLocations", props.row.cityId)}
                            />
                        </div>

                    </div>
                </div>

                <div className="removeIcon">
                    {props.index > 0 && (
                        <IconButton onClick={() => handleDeleteClick(props.index)}>
                            <img src={deleteIcon} alt="Delete" style={{ width: '24px', height: '24px' }} />
                        </IconButton>
                    )}
                </div>
            </div>

        </>
    );
}

export default Doctorpracticelocationrow;